import React, { Component, useContext } from "react";
import logo from "./logoSurcapColor.svg";

import { Layout, Menu, ConfigProvider } from "antd";
import {
  LogoutOutlined,
} from "@ant-design/icons";

import { Link, useLocation } from "react-router-dom";
import { GlobalContext } from "./GlobalContext";

import moment from "moment";
import "moment/locale/fr";
import frFR from "antd/lib/locale/fr_FR";

import {menuItems} from './constants.js';

const { Footer, Sider } = Layout;
const { SubMenu } = Menu;

moment.locale("fr");

const MainMenu = () => {
  let context = useContext(GlobalContext);
  const location = useLocation();

  let menu = [];
  menuItems.forEach((item, k) => {

    if (item.items.length === 0) {
      menu.push((
        <Menu.Item key={item.path} icon={item.icon}>
          <Link to={item.path}>{item.title}</Link>
        </Menu.Item>
      ))
    } else {
      let settingsSubMenu = [];
      item.items.forEach((subItem) => {
        if (subItem.roleIds.length === 0 || subItem.roleIds.indexOf(context.global.profile.role_id) > -1) {
          settingsSubMenu.push((
            <Menu.Item key={subItem.path}>
              <Link to={subItem.path}>{subItem.title}</Link>
            </Menu.Item>
          ))
        }
      })
  
      if (item.items.length > 0 && settingsSubMenu.length > 0) {
        menu.push((
          <SubMenu key={k} icon={item.icon} title={item.title}>      
            {settingsSubMenu}
          </SubMenu>
        ));
      }
    }
  })
  
  // location.pathname is '/users/new'
  return (
    <Menu mode="inline" selectedKeys={[location.pathname]}>
      
      {menu}
      <Menu.Item key="/login" className="my-4" icon={<LogoutOutlined />}>
        <Link to="/login">Déconnexion</Link>
      </Menu.Item>
    </Menu>
  );
};

class AppLayout extends Component {
  static contextType = GlobalContext;

  constructor() {
    super();
    this.state = {
      locale: frFR,
    };
  }

  render() {
    return (
      <ConfigProvider locale={this.state.locale}>
        <Layout className="site-layout" style={{ minHeight: "100vh" }}>
          <Sider collapsible theme="light" width="300px">
            <div className="logo">
              <img src={logo} />
            </div>
            <MainMenu />
          </Sider>
          <Layout className="site-layout">
            {this.props.children}
            <Footer style={{ textAlign: "center", display: "none" }}></Footer>
          </Layout>
        </Layout>
      </ConfigProvider>
    );
  }
}

export default AppLayout;
